module.exports = __webpack_public_path__ + "public/images/chat-send.8c14674a0d3142f00105440395ba7226.svg";